import styled from 'styled-components';
import { ButtonLarge } from 'components/Css';
import { Radio } from 'antd';

export const ResendButton = styled(ButtonLarge)`
  height: 50px;
    font-size: var(--font-medium);
  width: 100%;
  margin-top: var(--spacing-small);
`;

export const RadioGroupStyled = styled(Radio.Group) <{ onChange?: (e: any) => void }>`
  display: flex;
  flex-direction: column;

  .ant-radio-wrapper {
    margin-bottom: 16px;
  }

  .ant-radio-wrapper:last-child {
    margin-bottom: 0;
  }
`;

export const CircleInputContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  width: 460px;
  margin: var(--spacing-regular) auto;
  overflow: visible;
  
  @media (max-width: 500px) {
    zoom: 0.6;
  }
`;

export const Circle = styled.div`
  width: 50px;
  height: 50px;
  font-size: 24px;
  text-align: center;
  line-height: 50px;
  border-radius: 50%;
  margin: 0 3px;
  border: 1px solid var(--colorBorderBase);
  background-color: white;
  z-index: 1;
`;

export const HiddenInput = styled.input`
  position: absolute;
  height: 100%;
  top: 0;
  left: 36px;
  font-size: 33px;
  letter-spacing: 38.5px;
  padding-left: 44px;
  border: 0px !important;
  background-color: transparent;
  z-index: 2;
  cursor: pointer;

  -moz-appearance: textfield;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  &:focus {
    outline: none;
    box-shadow: none;
  }
`;
